import React from 'react';
import { ITableRow } from './table.model';
import cx from 'classnames';
import styles from './table.module.scss';

const TableRow = (props: ITableRow) => {
  const { children, className } = props;

  const classNames = cx(className);

  return <tr className={classNames}>{children}</tr>;
};

export default TableRow;

TableRow.displayName = 'Table.Row';
